import { graphql, Link, StaticQuery } from 'gatsby';
import React from 'react';
import { Link as LinkScroll } from "react-scroll";
import { getImage } from '../utils';
import showdown from 'showdown';
const converter = new showdown.Converter()

const links = [{
    name: "Inicio",
    to: "/",
    redirect: true
}, {
    name: "Blog",
    to: "/blog-page",
    redirect: true
}, {
    name: "Proyectos",
    to: "/projects-page",
    redirect: true
}, {
    name: "Contácto",
    to: "/contacts",
    redirect: true
}];

const Menu = ({
    location
}) => {
    return (
        <div
            className="collapse navbar-collapse"
            id="navbarSupportedContent">

            {/* MENU DESKTOP */}
            <ul className="d-none d-md-flex bg-1 pb-1 navbar-nav ml-auto align-items-center">
                {
                    links.map((item, index) => (
                        <li
                            key={`link${index}`}
                            className="d-flex align-items-center nav-item px-3">
                            {
                                item.redirect ? (
                                    <Link
                                        to={item.to}
                                        className={`nav-link ${location && location.pathname === item.to ? "active" : ""} text-white font-weight-bold pb-0`}>
                                        {item.name}
                                    </Link>
                                ) : (
                                        <>
                                            {
                                                location.pathname === "/" ? (
                                                    <LinkScroll
                                                        smooth={true}
                                                        duration={500}
                                                        to={item.to}
                                                        className={`c-pointer nav-link ${location && location.pathname.includes(item.to.replace("#", "/")) ? "active" : ""}  text-white font-weight-bold pb-0`}>
                                                        {item.name}
                                                    </LinkScroll>
                                                ) : (
                                                        <Link
                                                            to={`/#${item.to}`}
                                                            className={`nav-link ${location && location.pathname === item.to ? "active" : ""}  text-white font-weight-bold pb-0`}>
                                                            {item.name}
                                                        </Link>
                                                    )
                                            }
                                        </>
                                    )
                            }
                        </li>
                    ))
                }
            </ul>

            {/* MENU MOBILE */}
            <ul className="d-flex flex-column d-md-none  navbar-nav ml-auto align-items-center">
                {
                    links.map((item, index) => (
                        <li
                            key={`link${index}`}
                            className="mx-auto d-flex align-items-center nav-item">
                            {
                                item.redirect ? (
                                    <Link
                                        to={item.to}
                                        className={`nav-link ${location && location.pathname === item.to ? "active" : ""} text-muted font-weight-bold pb-0`}>
                                        {item.name}
                                    </Link>
                                ) : (
                                        <>
                                            {
                                                location.pathname === "/" ? (
                                                    <LinkScroll
                                                        smooth={true}
                                                        duration={500}
                                                        to={item.to}
                                                        className={`c-pointer nav-link ${location && location.pathname.includes(item.to.replace("#", "/")) ? "active" : ""}  text-muted font-weight-bold pb-0`}>
                                                        {item.name}
                                                    </LinkScroll>
                                                ) : (
                                                        <Link
                                                            to={`/#${item.to}`}
                                                            className={`nav-link ${location && location.pathname === item.to ? "active" : ""}  text-muted font-weight-bold pb-0`}>
                                                            {item.name}
                                                        </Link>
                                                    )
                                            }
                                        </>
                                    )
                            }
                        </li>
                    ))
                }
            </ul>
        </div>
    )
}

const Header = ({
    location,
    data
}) => {
    const logo = getImage(data.markdownRemark.frontmatter.header.logo);

    const {
        header: _header,
    } = data.markdownRemark.frontmatter;

    let header = {}

    const { pathname } = location;

    let isHeaderShow = false;
    if (pathname === "/") {
        isHeaderShow = true;
        header = {
            ..._header,
            img: {
                ..._header.image,
                imageSm: getImage(_header.image, "imageSm"),
                imageBig: getImage(_header.image, "imageBig"),
            }
        }
    } else if (pathname === "/projects-page") {
        isHeaderShow = true;
        header = {
            ..._header,
            img: {
                ..._header.imageProject,
                imageSm: getImage(_header.imageProject, "imageSm"),
                imageBig: getImage(_header.imageProject, "imageBig"),
            }
        }
    } else if (pathname === "/contacts") {
        isHeaderShow = true;
        header = {
            ..._header,
            img: {
                ..._header.imageContact,
                imageSm: getImage(_header.imageContact, "imageSm"),
                imageBig: getImage(_header.imageContact, "imageBig"),
            }
        }
    }

    return (
        <>
            <div
                id="header"
                className="container-fluid">
                <div className="container container-max">
                    <nav
                        // style={{ boxShadow: "0 2.5px 2px 0 rgba(0, 0, 0, 0.09)" }}
                        className="navbar navbar-expand-md navbar-light px-0">

                        {/* LOGO */}
                        <Link className="navbar-brand" to="/">
                            <img
                                className="img-fluid"
                                src={logo}
                                alt="placeholder"
                                style={{
                                    width: "60px",
                                    height: "120px"
                                }}
                            />
                        </Link>

                        {/* BUTTON TOGGLE */}
                        <button
                            className="navbar-toggler"
                            type="button"
                            data-toggle="collapse"
                            data-target="#navbarSupportedContent"
                            aria-controls="navbarSupportedContent"
                            aria-expanded="false"
                            aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon" />
                        </button>

                        {/* MENU */}
                        <Menu location={location} />
                    </nav>

                </div>
            </div>
            <div
                id="header"
                className="container-fluid px-0">
                <div
                    style={{ height: "30px" }}
                    className="bg-1" />
            </div>
            {
                isHeaderShow && (
                    <section
                        className="container-fluid cover p-0 m-0 position-relative"
                    >
                        <div className="container container-max bg-1 position-relative">
                            <img
                                style={{
                                    zIndex: "-1"
                                }}
                                width="1024"
                                height="600"
                                className="w-100 d-none d-md-block banner__desktop"
                                src={header.img.imageBig}
                                alt={header.img.alt}
                                loading="lazy" />

                            <img
                                style={{
                                    zIndex: "-1"
                                }}
                                style={{ height: "450px", objectFit: "cover" }}
                                className="w-100 d-block d-md-none"
                                src={header.img.imageSm}
                                alt={header.img.alt}
                                loading="lazy" />
                            <div
                                style={{
                                    zIndex: "2",
                                    top: "0",
                                    left: "0"
                                }}
                                className="position-absolute w-100 h-100 d-flex flex-column align-items-center justify-content-center">
                                <h1 className="text-center font-weight-bold text-white mb-0">
                                    <div
                                        dangerouslySetInnerHTML={{ __html: converter.makeHtml(header.img.title) }} />
                                </h1>
                                <h5 className="text-center font-weight-bold text-white">
                                    <div
                                        dangerouslySetInnerHTML={{ __html: converter.makeHtml(header.img.desc) }} />
                                </h5>
                            </div>
                        </div>
                    </section>
                )
            }
        </>
    )
}

export default props => (
    <StaticQuery
        query={graphql`
        query HeaderQuery {
            markdownRemark(frontmatter: { templateKey: { eq: "landing" } }) {
                frontmatter {
                    header {
                        image {
                            imageSm {
                                childImageSharp {
                                    fluid {
                                        ...GatsbyImageSharpFluid
                                    }
                                }
                                publicURL
                            }
                            imageBig {
                                childImageSharp {
                                    fluid {
                                        ...GatsbyImageSharpFluid
                                    }
                                }
                                publicURL
                            }
                            alt
                            title
                            desc
                        }
                        imageProject {
                            imageSm {
                                childImageSharp {
                                    fluid {
                                        ...GatsbyImageSharpFluid
                                    }
                                }
                                publicURL
                            }
                            imageBig {
                                childImageSharp {
                                    fluid {
                                        ...GatsbyImageSharpFluid
                                    }
                                }
                                publicURL
                            }
                            alt
                            title
                            desc
                        }
                        imageContact {
                            imageSm {
                                childImageSharp {
                                    fluid {
                                        ...GatsbyImageSharpFluid
                                    }
                                }
                                publicURL
                            }
                            imageBig {
                                childImageSharp {
                                    fluid {
                                        ...GatsbyImageSharpFluid
                                    }
                                }
                                publicURL
                            }
                            alt
                            title
                            desc
                        }
                        logo {
                            image {
                              childImageSharp {
                                  fluid {
                                      ...GatsbyImageSharpFluid
                                  }
                              }
                              publicURL
                            }
                            alt
                        }
                    }
                }
            }
        }
      `}
        render={(data, count) => <Header data={data} {...props} />}
    />
)